import { useCallback } from 'react';
import { useNavigator } from 'shared/src/utils';
import {
  startAppleLogin,
  startFacebookLogin,
  startKakaoLogin,
  startNaverLogin,
} from '../../../socialAuth';
import type { LoginType } from '../types';

/**
 * 로그인 버튼 press 처리 (웹).
 * 이메일은 화면 이동, 소셜은 provider authorize로 리다이렉트.
 */
export const useLoginPress = () => {
  const { navigator } = useNavigator();

  return useCallback(
    (type: LoginType) => {
      switch (type) {
        case 'email': {
          // 진입 URL(/login?redirect=)의 원래 페이지를 넘겨 로그인 성공 후 복귀시킨다.
          const redirect =
            new URLSearchParams(window.location.search).get('redirect') ??
            undefined;
          navigator.moveToEmailLogin(redirect);
          return;
        }
        case 'kakao':
          startKakaoLogin();
          return;
        case 'naver':
          startNaverLogin();
          return;
        case 'facebook':
          startFacebookLogin();
          return;
        case 'apple':
          startAppleLogin();
          return;
      }
    },
    [navigator],
  );
};
